import { TDeleteP5FReq } from "@sharedTypes/req.type";
import { TDeleteP5FRes } from "@sharedTypes/res.type";

import missingParametersError from "api/Error";
import axios from "axios";

export async function DeleteP5F(saveId: string) {
  const apiUrl = "/tools/p5f/DeleteP5F";

  const body: TDeleteP5FReq = {
    id: saveId,
  };

  for (const [key, param] of Object.entries(body)) {
    if (param === undefined) throw missingParametersError(key);
  }

  const data: TDeleteP5FRes = await axios
    .post(apiUrl, body)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      throw err.response.data;
    });
  return data;
}
